
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Actions/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Actions/model.ts';
            var controllerExport0 = _controllerExport0;
            

            
import wrapController1 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller1 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Badges/viewer.controller.ts';
            import * as _controllerExport1 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Badges/model.ts';
            var controllerExport1 = _controllerExport1;
            

            
import wrapController2 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller2 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Device/viewer.controller.ts';
            import * as _controllerExport2 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Device/model.ts';
            var controllerExport2 = _controllerExport2;
            

            
import wrapController3 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller3 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Device and bg/viewer.controller.ts';
            import * as _controllerExport3 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Device and bg/model.ts';
            var controllerExport3 = _controllerExport3;
            

            
import wrapController4 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller4 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Phone input/viewer.controller.ts';
            import * as _controllerExport4 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Phone input/model.ts';
            var controllerExport4 = _controllerExport4;
            

            
import wrapController5 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller5 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Presets/viewer.controller.ts';
            import * as _controllerExport5 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Presets/model.ts';
            var controllerExport5 = _controllerExport5;
            

            
import wrapController6 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller6 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Presets1/viewer.controller.ts';
            import * as _controllerExport6 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Presets1/model.ts';
            var controllerExport6 = _controllerExport6;
            

            
import wrapController7 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller7 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/QR Code/viewer.controller.ts';
            import * as _controllerExport7 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/QR Code/model.ts';
            var controllerExport7 = _controllerExport7;
            

            
import wrapController8 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller8 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/QR code plus Badges/viewer.controller.ts';
            import * as _controllerExport8 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/QR code plus Badges/model.ts';
            var controllerExport8 = _controllerExport8;
            

            
import wrapController9 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller9 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/SMS Messages/viewer.controller.ts';
            import * as _controllerExport9 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/SMS Messages/model.ts';
            var controllerExport9 = _controllerExport9;
            

            
import wrapController10 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller10 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Title and description/viewer.controller.ts';
            import * as _controllerExport10 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Title and description/model.ts';
            var controllerExport10 = _controllerExport10;
            

            
import wrapController11 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller11 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Widget1/viewer.controller.ts';
            import * as _controllerExport11 from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Widget1/model.ts';
            var controllerExport11 = _controllerExport11;
            

  
  var importedApp = {};


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = null;

  var experimentsConfig = {"centralized":true,"scopes":[]};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/assets/locales/messages_en.json","availableLanguages":["en"]};

  var defaultTranslations = {"download_my_app.widget.global_design.presets":"Choose a layout","download_my_app.widget.global_design.inputs":"Dropdown & input field","download_my_app.widget.elements_gfpp":"Choose Elements","download_my_app.widget.description.label":"Description","download_my_app.widget.send_button.main_action":"Change Text & Icon","download_my_app.widget.app_store.link.dine":"https://apps.apple.com/bb/app/dine-by-wix/id1561524113","download_my_app.widget.description.main_action":"Edit Description","download_my_app.widget.app_store.link.spaces":"https://apps.apple.com/us/app/spaces-follow-businesses/id1099748482","download_my_app.widget.description.main_action_2":"Design Description","download_my_app.widget.qrBackground.label":"Background Box","download_my_app.panel.description.label":"Description text","download_my_app.widget.deviceBg.label":"Background Box","download_my_app.widget.description.fit":"Download the Fit by Wix app and join “{siteName}” to easily stay updated on the go.","download_my_app.widget.badges.label":"App Buttons","download_my_app.panel.title.label":"Title text","download_my_app.widget.deviceBg.main_action":"Design","download_my_app.widget.serverError":"An error occurred sending the link. Try again","download_my_app.widget.phone_number.main_action":"Customize Design","download_my_app.panel.title.placeholder":"Add a catchy title…","download_my_app.widget.global_design.edit":"Edit Design","download_my_app.widget.global_design.title":"Widget Design","download_my_app.widget.google_play.link.spaces":"https://play.google.com/store/apps/details?id=com.wix.android&hl=en&gl=US","download_my_app.widget.global_design.device":"App preview box","download_my_app.widget.phone_inputs":"Input Fields","download_my_app.panel.description.placeholder":"Add a description that invites people to download your app…","download_my_app.panel.description.title":"Edit Description","download_my_app.widget.elements_gfpp.first_category":"What would you like to display?","download_my_app.widget.qr_code.label":"QR Code","download_my_app.widget.description.dine":"Download the Dine by Wix app and add “{siteName}” to easily stay updated on the go.","download_my_app.widget.global_design.background":"Widget background","download_my_app.widget.presets_widget_label":"Download the Mobile App","download_my_app.widget.invalidPhone":"Please insert a valid phone number.","download_my_app.widget.phoneNumber.placholder":"Add your number...","download_my_app.widget.elements_gfpp.sms":"SMS invite link","download_my_app.widget.device.label":"App preview box","download_my_app.widget.title.main_action_2":"Design Title","download_my_app.panel.title.title":"Edit Title","download_my_app.widget.elements_gfpp.qr":"Scan QR code","download_my_app.widget.app_store.link.fit":"https://apps.apple.com/us/app/fit-by-wix/id1552621043","download_my_app.widget.phoneNumber":"Phone number","download_my_app.widget.app_store.alt":"Download on the App Store","download_my_app.widget.success":"Download link sent successfully.","download_my_app.widget.title.label":"Title","download_my_app.widget.countryCode":"Country","download_my_app.widget.elements_gfpp.second_category":"How will visitors join your app?","download_my_app.widget.country_code.label":"Dropdown","download_my_app.widget.background.label":"Background Box","download_my_app.widget.elements_gfpp.badges":"Google Play & App Store","download_my_app.widget.description.branded":"Download the “{siteName}” app to easily stay updated on the go.","download_my_app.widget.qr_code_description":"Scan the QR code to get an invite link.","download_my_app.widget.title":"Join us on mobile!","download_my_app.widget.phone_number.label":"Text Input Field","download_my_app.widget.global_design.device_background":"App Preview Background","download_my_app.widget.global_design.description":"Description","download_my_app.widget.elements_gfpp.title":"Title","download_my_app.widget.title.dine":"Add us on mobile!","download_my_app.widget.send_button.label":"Send button","download_my_app.widget.description.spaces":"Download the Spaces by Wix app and join “{siteName}” to easily stay updated on the go.","download_my_app.widget.elements_gfpp.description":"Description","download_my_app.widget.elements_gfpp.mobile_preview":"App preview","download_my_app.widget.country_code.main_action":"Customize Design","download_my_app.widget.google_play.link.dine":"https://play.google.com/store/apps/details?id=com.wix.restaurants&hl=en&gl=US","download_my_app.widget.global_design.button":"Send button","download_my_app.widget.sendButton":"Send","download_my_app.widget.google_play.link.fit":"https://play.google.com/store/apps/details?id=com.wix.fitness&hl=en&gl=US","download_my_app.widget.google_play.alt":"Get it on Google Play","download_my_app.widget.qr.alt":"Scan QR code to join the app","download_my_app.widget.title.main_action":"Edit Title","download_my_app.widget.global_design.app_title":"Title"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "download-my-app-blocks",
    biConfig: null,
    appName: "Download My App - Blocks",
    appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Actions/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Actions",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-h5ysb" }, { method: controller1,
          wrap: wrapController1,
          exports: controllerExport1,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Badges/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Badges",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-cg8ox" }, { method: controller2,
          wrap: wrapController2,
          exports: controllerExport2,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Device/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Device",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-rnuwe" }, { method: controller3,
          wrap: wrapController3,
          exports: controllerExport3,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Device and bg/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Device and bg",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-kknhr" }, { method: controller4,
          wrap: wrapController4,
          exports: controllerExport4,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Phone input/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Phone input",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-x0ztp" }, { method: controller5,
          wrap: wrapController5,
          exports: controllerExport5,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Presets/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Presets",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-mbv14" }, { method: controller6,
          wrap: wrapController6,
          exports: controllerExport6,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Presets1/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Presets1",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-ukp2t" }, { method: controller7,
          wrap: wrapController7,
          exports: controllerExport7,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/QR Code/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "QR Code",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-vzkfh" }, { method: controller8,
          wrap: wrapController8,
          exports: controllerExport8,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/QR code plus Badges/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "QR code plus Badges",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-rnrxn" }, { method: controller9,
          wrap: wrapController9,
          exports: controllerExport9,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/SMS Messages/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "SMS Messages",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-b2wqx" }, { method: controller10,
          wrap: wrapController10,
          exports: controllerExport10,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Title and description/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Title and description",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-vlznd" }, { method: controller11,
          wrap: wrapController11,
          exports: controllerExport11,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/8e2f873a56a3272e/packages/download-my-app-blocks/src/components/Widget1/viewer.controller.ts",
          appName: "Download My App - Blocks",
          appDefinitionId: "778ca2ab-ffa5-4b98-b2e3-8727de469c86",
          projectName: "download-my-app-blocks",
          componentName: "Widget1",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "778ca2ab-ffa5-4b98-b2e3-8727de469c86-j7nli" }],
    false);

    export const createControllers = _createControllers
